export const GET_DUPL_BIO_DETAILS = "GET_DUPL_BIO_DETAILS"
export const GET_DUPL_BIO_DETAILS_ERR = "GET_DUPL_BIO_DETAILS_ERR"

export const CHANGE_COUNT_ROUTE = "CHANGE_COUNT_ROUTE"